import css from 'highlight.js/lib/languages/css';
import js from 'highlight.js/lib/languages/javascript';
import ts from 'highlight.js/lib/languages/typescript';
import html from 'highlight.js/lib/languages/xml';
import php from 'highlight.js/lib/languages/php';
import bash from 'highlight.js/lib/languages/bash';
import { createLowlight } from 'lowlight';

const lowLight = createLowlight();
lowLight.register('bash', bash);
lowLight.register('js', js);
lowLight.register('ts', ts);
lowLight.register('php', php);
lowLight.register('html', html);
lowLight.register('css', css);
export const lowlightConfig = lowLight;
